import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Pipeline } from 'utils/types';

import c from '../utils/constants';
import { pipelineTransformer } from '../transformer';

export default function useGetPipelines(params: { [key: string]: any } = {}) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useQuery<Pipeline[], ApiError>({
    queryKey: [c.PIPELINES, params],
    queryFn: async () => {
      const api = new Api(args);
      if (params?.keyword) {
        params.keyword = params.keyword.replace('+', '');
      }
      const data: { data: Pipeline[]; meta: any } = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/sales/pipelines',
            transformer: pipelineTransformer.pipelines,
            params: { ...params, include: ['deal'] },
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/sales/pipelines`,
            transformer: pipelineTransformer.pipelines,
            params: { ...params, include: ['deal'] },
          },
        }),
      );

      return data?.data;
    },
  });
}
